// removed by extract-text-webpack-plugin
module.exports = {"contact-us":"src-pages----contact-module---contact-us---21duB","text-container":"src-pages----contact-module---text-container---hi3A9","bg-square-1":"src-pages----contact-module---bg-square-1---3W_F1","bg-square-2":"src-pages----contact-module---bg-square-2---JjoY8","splash-image-container":"src-pages----contact-module---splash-image-container---2tYkK"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/contact.module.scss
// module id = 206
// module chunks = 70144966829960 247968605717249